// import { useEffect, useState } from "react";

// export default function Counter({
//   end,
//   duration = 2000,
//   suffix = "",
//   className = "",
// }) {
//   const [count, setCount] = useState(0);

//   useEffect(() => {
//     let start = 0;

//     const increment = end / (duration / 16);

//     const timer = setInterval(() => {
//       start += increment;

//       if (start >= end) {
//         setCount(end);
//         clearInterval(timer);
//       } else {
//         setCount(Math.floor(start));
//       }
//     }, 16);

//     return () => clearInterval(timer);
//   }, [end, duration]);

//   return (
//     <span className={className}>
//       {count}
//       {suffix}
//     </span>
//   );
// }

import { useEffect, useRef, useState } from "react";

export default function Counter({
  end,
  duration = 2000,
  suffix = "",
  className = "",
}) {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const counterRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.3,
      },
    );

    if (counterRef.current) {
      observer.observe(counterRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    let start = 0;
    const increment = end / (duration / 16);

    const timer = setInterval(() => {
      start += increment;

      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [isVisible, end, duration]);

  return (
    <span
      ref={counterRef}
      className={className}
    >
      {count}
      {suffix}
    </span>
  );
}
